import React, { useState, } from 'react';

const CitationsRetryForm = ({ loading, onSubmit, }) => {
  const [txnId, setTxnId] = useState('');

  const handleSubmit = () => {
    if (!txnId.trim()) return;
    onSubmit({ txnId: txnId.trim(), });
  };

  return (
    <div className='mt-3'>
      <div className='mb-3'>
        <label htmlFor='txnId'>Transaction ID</label>
        <input
          id='txnId'
          type='text'
          className='form-control'
          placeholder='Enter transaction ID'
          value={txnId}
          onChange={(e) => setTxnId(e.target.value)}
          disabled={loading}
        />
      </div>
      <button
        type='button'
        className='btn btn-primary'
        onClick={handleSubmit}
        disabled={!txnId.trim() || loading}
      >
        {loading ? 'Retrying...' : 'Retry'}
      </button>
    </div>
  );
};

export default CitationsRetryForm;
